/* Duck Commander sponsors marquee
   -----------------------------------------------------------------------------
   The markup renders two identical <ul class="dc-sponsors__track"> copies inside
   .dc-sponsors__marquee; each copy animates translateX(0 -> -100%) on loop. That
   loop is only seamless when ONE track copy is at least as wide as the marquee
   viewport — otherwise, when the first copy scrolls fully out, the second copy
   can't cover the viewport and a blank gap appears that "jumps" on every loop.

   With a short sponsor list the single copy is narrower than wide desktops, so
   here we clone the original item set into each track until the track is at
   least as wide as the viewport. The animation duration is scaled by the number
   of copies so the perceived scroll speed (px/sec) stays exactly what the
   section's "duration" setting intends, regardless of how many copies we add. */
(function () {
  function fillMarquee(marquee) {
    var tracks = marquee.querySelectorAll('.dc-sponsors__track');
    if (!tracks.length) return;

    var baseDuration = parseFloat(marquee.getAttribute('data-duration')) || 40;

    // Snapshot the original item set once (from the first track).
    if (!marquee.__baseItems) {
      marquee.__baseItems = Array.prototype.map.call(
        tracks[0].children,
        function (li) { return li.cloneNode(true); }
      );
    }
    var base = marquee.__baseItems;
    if (!base.length) return;

    var viewport = marquee.clientWidth || marquee.offsetWidth || 0;

    var copies = 1;
    tracks.forEach(function (track, i) {
      // Reset to a single clean copy of the original set.
      track.innerHTML = '';
      base.forEach(function (li) { track.appendChild(li.cloneNode(true)); });

      // Repeat the set until this track copy spans the viewport. Only the first
      // track needs measuring; mirror the result onto every track so they stay
      // identical (required for the -100% loop to line up seamlessly).
      if (i === 0) {
        var guard = 0;
        while (track.scrollWidth < viewport && guard < 24) {
          base.forEach(function (li) { track.appendChild(li.cloneNode(true)); });
          copies++;
          guard++;
        }
      } else {
        for (var c = 1; c < copies; c++) {
          base.forEach(function (li) { track.appendChild(li.cloneNode(true)); });
        }
      }
    });

    // Keep scroll speed constant: more copies => proportionally longer duration.
    var duration = baseDuration * copies;
    tracks.forEach(function (track) {
      track.style.animationDuration = duration + 's';
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-dc-marquee]');
    nodes.forEach(function (node) {
      var duration = parseFloat(node.getAttribute('data-duration')) || 40;
      node.style.setProperty('--dc-sponsors-duration', duration);
      fillMarquee(node);
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    init();

    // Re-fill on viewport changes so the track keeps spanning the viewport.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-dc-marquee]').forEach(fillMarquee);
      }, 250);
    }, { passive: true });
  });

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
